export const normalizeReceiptPaperWidth = (value) =>
  Number(value) === 58 ? 58 : 80;

export const normalizeReceiptCopies = (value) => {
  const copies = Math.floor(Number(value));
  return Number.isFinite(copies) && copies >= 1 ? copies : 1;
};

export const buildReceiptPrinterForm = (settings = {}) => ({
  connection_type:
    String(settings.connection_type || "").toLowerCase() === "usb"
      ? "usb"
      : String(settings.connection_type || "").toLowerCase() === "direct_rj45"
        ? "direct_rj45"
        : "ethernet",
  printer_name: settings.printer_name || "Ticket caisse",
  ip_address: settings.ip_address || "",
  port: Number(settings.port) || 9100,
  copies: normalizeReceiptCopies(settings.copies),
  paper_width_mm: normalizeReceiptPaperWidth(settings.paper_width_mm),
});
